export default __webpack_public_path__ + "static/media/stillness.44c301b1.jpg";